module.exports = __webpack_public_path__ + "img/coupons.3b5825a2.png";